import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { ICommodity } from '../commodity/commodity';
import { IOptionType } from '@zz2/zz2-ui';
import { ICommodityState } from './commodityState';
import { ICommodityStateFormValues } from './commodityStateFormValues';
import { ICommodityStateUpsert } from './commodityStateUpsert';

export default class CommodityStateModelHelper {
    public static createFormValues = (
        commodityState : ICommodityState | null,
        commodities : Array<ICommodity>,
        defaultCommodity : ICommodity | null
    ) : ICommodityStateFormValues => {
        if (!commodityState) return {
            id: 0,
            guid: uuidV4(),
            name: '',
            commodities: defaultCommodity
                ? [{ // TODO: OptionType.FromDataModel
                    value: defaultCommodity.id,
                    label: `(${defaultCommodity.code}) - ${defaultCommodity.name}`,
                }]
                : [],
            isActive: true,
        };

        const commoditiesOptions = commodities
            .filter(x => x.isActive && commodityState.commodityIds.includes(x.id))
            .map(x => { // TODO: OptionType.FromDataModel
                return {
                    value: x.id,
                    label: `(${x.code}) - ${x.name}`,
                }
            });

        return {
            id: commodityState.id,
            guid: commodityState.guid,
            name: commodityState.name,
            commodities: commoditiesOptions,
            isActive: commodityState.isActive,
        };
    };

    public static createUpsert = (formValues : ICommodityStateFormValues) : ICommodityStateUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            name: formValues.name,
            commodityIds: formValues.commodities.map(x => Number(x.value)),
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ICommodityStateFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        commodities: Yup.array<IOptionType>().defined().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
